module.exports = __webpack_public_path__ + "img/home-top.b7b7cace.png";